import React from "react";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import {
  ProductDetailPageResult,
  VariationMembership,
} from "../ProductDetailPageResult";
import ProductSchema from "./ProductSchema";
import ThreeDModelSchema from "./ThreeDModelSchema";
import VideosSchema from "./VideosSchema";
import ProductGroupSchema from "./ProductGroupSchema";
import { useProductDetailPageData } from "..";

interface Props {
  activeProduct: ProductDetailPageResult;
  user: User;
  variationMembership?: VariationMembership;
}

const Schemas = connectUserAndChat(
  ({ activeProduct, user, variationMembership }: Props) => {
    const { groupMembers = [] } = useProductDetailPageData();
    const hasVariationGroup = !!variationMembership?.variationGroups?.length;

    return (
      <>
        {!hasVariationGroup && (
          <ProductSchema activeProduct={activeProduct} user={user} />
        )}
        {(!!groupMembers?.length || hasVariationGroup) && (
          <ProductGroupSchema activeProduct={activeProduct} user={user} />
        )}
        {!!activeProduct.videos?.length && (
          <VideosSchema
            videos={activeProduct.videos}
            itemNumber={activeProduct.itemNumber}
          />
        )}
        {activeProduct.modelFiles && (
          <ThreeDModelSchema product={activeProduct} />
        )}
      </>
    );
  },
);

export default Schemas;
